module.exports = __webpack_public_path__ + "img/logo_facebook.f1dd41de.png";